import { formatDateISO, formatDateTimeISO } from './formatDate'
import { isDate, isString, isNumber } from './typeChecking'

const dateToISOStr = (date, withTime) => {
  try {
    if (!date && !isDate(date) && !isString(date) && !isNumber(date)) {
      return null
    }

    const parsedDate = new Date(date)
    if (isNaN(parsedDate.getTime())) {
      return null
    }

    return withTime
      ? formatDateTimeISO(parsedDate).substring(0, 16)
      : formatDateISO(parsedDate).substring(0, 10)
  } catch (e) {
    console.error(e)
  }
  return null
}

export default dateToISOStr
